import { DrugDiseaseInteraction } from "domain/entities/drug-disease-interaction";
import { Result } from "domain/entities/result";
import { DrugDiseaseInteractionRepository } from "domain/repositories";

export default class UpdateUseCase {
    private drugDiseaseInteractionRepository: DrugDiseaseInteractionRepository;
    
    public constructor(drugDiseaseInteractionRepository: DrugDiseaseInteractionRepository) {
        this.drugDiseaseInteractionRepository = drugDiseaseInteractionRepository
    }

    public async updateDrugDiseaseInteraction(id: number, drugDiseaseInteraction: DrugDiseaseInteraction, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugDiseaseInteractionRepository.updateDrugDiseaseInteraction(id, drugDiseaseInteraction, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}